import { render, staticRenderFns } from "./InquiryFilter.vue?vue&type=template&id=a4824574"
import script from "./InquiryFilter.vue?vue&type=script&lang=ts"
export * from "./InquiryFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports